import { Box, Button, Typography } from "@mui/material";
import { Home } from "@mui/icons-material";
import { useNavigate } from "react-router";
import { styled } from "@mui/system";
import Logo from "../assets/img/UI.png";

const Main = styled(Box)(({ theme }) => ({
    background: theme.palette.grey[200],
    height: "100vh",
    width: "100%",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
}));

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <Main>
            <img
                src={Logo}
                alt="Logo"
                className="image mb-2"
                width="64px"
                height="64px"
            />
            <Typography variant="h1">Seite nicht gefunden</Typography>
            <Button
                onClick={() => navigate("/")}
                className="mt-2 d-flex align-items-center"
                variant="outlined"
                startIcon={<Home />}
            >
                Zur Startseite
            </Button>
        </Main>
    );
};

export default NotFound;
